export default __webpack_public_path__ + "static/media/IncredibleAnimalsMigrators_08.596f708a.png";